import { useTranslation } from 'next-i18next';
import { usePublicCategories, usePublicCategoryFilter } from '@/module/public/hooks';
import { formatGradeLabel, formatSemesterLabel } from '@/module/public/util/schoolInfoLabel';
import { Checkbox } from '@/ui';
import { Label } from '@/ui/components/label';
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/ui_v3/components/accordion';
import { isAllGrades } from '@/views/build/util';
import { FilterAccordionId } from '../../stores/AccordionStore';
export const SchoolAccordionItems = () => {
  const {
    t
  } = useTranslation(['common']);
  const {
    handleSelectedSemesters,
    handleSelectedGrades,
    selectedGrades,
    selectedSemesters
  } = usePublicCategoryFilter();
  const {
    grades,
    semesters
  } = usePublicCategories();
  const isOnlyAllGradesSelected = selectedGrades.length === 1 && isAllGrades(selectedGrades[0]);
  const hasGradeOptions = grades.length > 0;
  const AccordionItems = [{
    type: FilterAccordionId.Grade,
    name: t('school.info.grade'),
    nodes: grades.map(g => ({
      ...g,
      name: formatGradeLabel(t, g.categoryGroupId)
    }))
  }, {
    type: FilterAccordionId.Semester,
    name: t('school.info.semester'),
    nodes: semesters.map(s => ({
      ...s,
      name: formatSemesterLabel(t, s.value)
    })),
    hidden: !hasGradeOptions || isOnlyAllGradesSelected
  }].filter(d => d.nodes.length > 0 && !d.hidden);
  return AccordionItems.map(({
    type,
    name,
    nodes
  }) => <AccordionItem key={type} value={type}>
      <AccordionTrigger>{name}</AccordionTrigger>
      <AccordionContent className={'grid grid-cols-2 gap-x-3xs gap-y-sm p-md'}>
        {nodes.map(node => {
        const key = type + node.value;
        return <div className={'flex h-full min-h-[24px] w-[125px] items-center gap-xs'} key={key}>
              <Checkbox className={'text-body-md-semibold'} checked={type === FilterAccordionId.Grade ? selectedGrades.includes(node.value) : selectedSemesters.includes(node.value)} id={key} onCheckedChange={() => {
            void (type === FilterAccordionId.Grade ? handleSelectedGrades(node.value) : handleSelectedSemesters(node.value));
          }} />
              <Label className={'cursor-pointer text-body-md-semibold'} htmlFor={key}>
                {String(node.name)}
              </Label>
            </div>;
      })}
      </AccordionContent>
    </AccordionItem>);
};